<template>
  <div>
    <div class="attachments-box">
      <custom-select
        class="mt-2"
        default-value="AGREEMENT"
        :options="types"
        :graySelect="true"
        :prePick="'AGREEMENT'"
        @newPick="(e) => (selectedType = e)"
      />

      <custom-button
        :disabled="generatingInProgress"
        @click="
          selectedType === 'AGREEMENT' || selectedType === 'AGREEMENT_COMPANY'
            ? openAgreementDateModal()
            : generatePdf()
        "
        class="mb-1"
        :title="!generatingInProgress ? 'Wygeneruj' : 'Generowanie...'"
        :size="'small'"
      />

      <button
        style="visibility: hidden"
        id="agreement-date-modal-open"
        type="button"
        data-toggle="modal"
        data-target="#agreement-date-modal"
      />
    </div>

    <div class="employee-attachments">
      <p v-for="file in attachments" :key="file.id">
        <span>{{ file.originalName }}</span>
        <span class="preview" @click="getAttachment(file)"> Podgląd</span>
      </p>
    </div>

    <div class="bills" v-if="panelCan('showBills')">
      <table
        class="table table-striped table-sm"
        v-if="bills && bills.bills && bills.bills.length > 0"
      >
        <thead>
          <tr style="width: 100%">
            <th scope="col">Numer rachunku</th>
            <th scope="col">Okres</th>
            <th scope="col">Wartość</th>
            <th scope="col">Ilość zleceń</th>
            <th scope="col">Wykonane godziny</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="bill in bills.bills" :key="bill.id">
            <td>{{ bill.number }}</td>
            <td>{{ translateMonth(bill.month, bill.year) }}</td>
            <td>
              {{ (Math.round(bill.price * 100.0) / 100.0).toFixed(2) }} zł
            </td>
            <td>{{ bill.number_of_orders }}</td>
            <td>{{ bill.completed_hours }}</td>
            <td>
              <button
                @click="downloadBillPdf(bill.id)"
                type="button"
                class="btn btn-outline-dark"
              >
                Pobierz
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <custom-modal
      :title="'Wybierz datę podpisania umowy'"
      :id="'agreement-date-modal'"
    >
      <template #content>
        <div class="agreement-date">
          <datepicker
            :monday-first="true"
            :language="pl"
            v-model="agreementDate"
            name="agreementDate"
            :placeholder="'Data podpisania umowy'"
            clearable
          ></datepicker>
        </div>
        <div class="modal-buttons">
          <custom-button
            :disabled="generatingInProgress"
            @click="closeAgreementModal()"
            :size="'small'"
            :title="'Anuluj'"
            :gray="true"
            :customStyles="'width: 50%'"
          />
          <custom-button
            :disabled="generatingInProgress"
            @click="generatePdf()"
            :size="'small'"
            :title="
              !generatingInProgress ? 'Wygeneruj umowę' : 'Generowanie...'
            "
            :gradient="true"
            :customStyles="'width: 50%'"
          />
        </div>
      </template>
    </custom-modal>
  </div>
</template>

<script>
import axios from "../../axiosDod";
import CustomButton from "../CustomButton.vue";
import CustomSelect from "../CustomSelect.vue";
import moment from "moment";
import CustomModal from "../CustomModal.vue";
import Datepicker from "vuejs-datepicker";
import { pl } from "vuejs-datepicker/dist/locale";
export default {
  components: { CustomSelect, CustomButton, CustomModal, Datepicker },
  props: ["employeeId", "firstName", "lastName"],
  data() {
    return {
      types: [
        {
          value: "AGREEMENT",
          shortName: "Umowa Fundacja",
          name: "Umowa Fundacja",
        },
        {
          value: "AGREEMENT_COMPANY",
          shortName: "Umowa Spółka",
          name: "Umowa Spółka",
        },
        {
          value: "DECISTION",
          shortName: "Oświadczenie do celów podatkowych",
          name: "Oświadczenie do celów podatkowych",
        },
      ],
      selectedType: "AGREEMENT",
      agreementDate: new Date(),
      pl,
      generatingInProgress: false,
    };
  },

  methods: {
    closeAgreementModal() {
      const buttonToClose = document.getElementById(
        "agreement-date-modal-close"
      );
      if (buttonToClose) {
        buttonToClose.click();
      }
    },

    async downloadBillPdf(billId) {
      const response = await axios.get(`employees/bills/${billId}`, {
        responseType: "arraybuffer",
      });

      const blob = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(blob);

      const fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", `rachunek_${billId}.pdf`);
      document.body.appendChild(fileLink);
      fileLink.click();
    },
    translateMonth(month, year) {
      return moment(`${year}-${month}-01`).locale("pl").format("MMMM YYYY");
    },
    async getAttachment(file) {
      const { id, originalName, mimetype } = file;
      const response = await axios.get(`cdn/${id}`, {
        responseType: "arraybuffer",
      });

      const blob = new Blob([response.data], { type: mimetype });
      const fileURL = URL.createObjectURL(blob);

      const fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", originalName);
      document.body.appendChild(fileLink);
      fileLink.click();
    },

    async openAgreementDateModal() {
      const button = document.getElementById("agreement-date-modal-open");
      if (button) {
        button.click();
      }
    },
    async generatePdf() {
      try {
        this.generatingInProgress = true;
        if (this.selectedType === "AGREEMENT") {
          const response = await this.$store.dispatch("generateAgreementPdf", {
            employeeId: this.employeeId,
            signingDate: this.agreementDate,
          });
          const fileURL = window.URL.createObjectURL(new Blob([response]));
          const fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            `umowa_fundacja_${this.firstName.toLowerCase()}_${this.lastName.toLowerCase()}.pdf`
          );
          document.body.appendChild(fileLink);
          fileLink.click();
        }

        if (this.selectedType === "AGREEMENT_COMPANY") {
          const response = await this.$store.dispatch(
            "generateAgreementCompanyPdf",
            {
              employeeId: this.employeeId,
              signingDate: this.agreementDate,
            }
          );
          const fileURL = window.URL.createObjectURL(new Blob([response]));
          const fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            `umowa_spolka_${this.firstName.toLowerCase()}_${this.lastName.toLowerCase()}.pdf`
          );
          document.body.appendChild(fileLink);
          fileLink.click();
        }

        if (this.selectedType === "DECISTION") {
          const response = await this.$store.dispatch(
            "generateStatementPdf",
            this.employeeId
          );
          const fileURL = window.URL.createObjectURL(new Blob([response]));
          const fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            `oswiadczenie_${this.firstName.toLowerCase()}_${this.lastName.toLowerCase()}.pdf`
          );
          document.body.appendChild(fileLink);
          fileLink.click();
        }

        this.closeAgreementModal();
      } catch (error) {
        console.log(error);
      } finally {
        this.generatingInProgress = false;
      }
    },
  },
  computed: {
    attachments() {
      return this.$store.getters.getDodSelectedEmployeeAttachments;
    },
    bills() {
      return this.$store.getters.getDodEmployeeBills;
    },
  },
};
</script>

<style  scoped>
.attachments-box {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
}

.customer-attachments {
  padding: 1rem;
  width: fit-content;
  font-size: 16px;
  padding: 2rem;
}
.preview {
  cursor: pointer;
  text-decoration: underline;
  margin-left: 1rem;
}
.modal-buttons {
  display: flex;
  gap: 10px;
  justify-content: center;
}
.agreement-date {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>